module.exports = __webpack_public_path__ + "static/media/returned.a4755e67.svg";